import { getFullName } from "helpers";
import { CommissionScenarioTypes, CommissionStatusTypes } from "types";

export function getCommissionsSplitFriendlyId(profile) {
	return `CS-${profile?.user_friendly_id}`;
}

export function convertCommissionSplitsValues(data) {
	let values = {
		id: data?.id,
		commissionSplitInfo: {
			userFriendlyId: getCommissionsSplitFriendlyId(data),
			profileName: data?.name,
			scenarioType: CommissionScenarioTypes.getByValue(data?.scenario),
			status: CommissionStatusTypes.getByName(
				data?.is_available?.toString(),
			),
			totalRevenueShare: data?.total_revenue_share,
		},
		primarySplitInformation: {
			agentId: data.primary_split_information.agent_id,
			agent: {
				id: data?.primary_split_information?.agent_id,
				firstName: data?.primary_split_information.agent?.first_name,
				lastName: data?.primary_split_information.agent?.last_name,
				name: `${getFullName(data.primary_split_information?.agent)} ${
					data.primary_split_information.agent.is_active
						? ""
						: "(inactive)"
				}`,
				entityType: data.primary_split_information.agent?.entity_type,
				partnerType: data.primary_split_information.agent?.partner_type,
				partnerTypeDisplayName:
					data?.primary_split_information?.agent
						.partner_type_display_name,
			},

			splitPercent: data?.primary_split_information?.split_percent,
			entityType: data?.primary_split_information?.agent?.entity_type,
		},
		secondarySplitInformation: data.secondary_split_information.map(s => ({
			agentId: s.agent_id,
			agent: {
				id: s.agent_id,
				firstName: s.agent.first_name,
				lastName: s.agent.last_name,
				name: `${getFullName(s.agent)} ${
					s.agent.is_active ? "" : "(inactive)"
				}`,
				entityType: s.agent.entity_type,
				partnerType: s.agent.partner_type,
				partnerTypeDisplayName: s.agent.partner_type_display_name,
			},
			splitPercent: s.split_percent,
			isPrivate: s.is_private,
			isUseSecondaryAgentScheduleForCalculations:
				s.is_agent_schedule_used_for_calculation?.toString(),
		})),
	};
	return values;
}

export const mapCommissionSplitToSend = (formData: { [key: string]: any }) => ({
	name: formData?.profileName,
	scenario: formData?.scenarioType?.value,
	is_available:
		formData?.status?.value === CommissionStatusTypes.Available.value,
	total_revenue_share: formData?.totalRevenueShare,
	primary_split_information: {
		split_percent:
			formData?.scenarioType?.value ===
			CommissionScenarioTypes.StraightSplit.value
				? formData?.totalRevenueShare
				: formData?.primarySplitInformation?.splitPercent,
	},
	secondary_split_information:
		formData?.scenarioType?.value !==
		CommissionScenarioTypes.StraightSplit.value
			? formData?.secondarySplitInformation?.map(section => ({
					is_private: section.isPrivate,
					agent_id: section.agent?.id,
					is_agent_schedule_used_for_calculation:
						section.isUseSecondaryAgentScheduleForCalculations,
					split_percent: section.splitPercent,
			  }))
			: null,
});
